<!--  

FILTRO PEDIDOS POR USUARIOS, EQUIPES UTILIZADO E ORIGEM

-->



<script>

import { SysVars } from '../main';

export default {
    props: {
        query: Object,
        filterTipos: { type: Boolean, default: false },
        filterEspera: { type: Boolean, default: false },
        filterEquipes: { type: Boolean, default: false },
        filterUsuarios: { type: Boolean, default: false },
        filterStatus: { type: Boolean, default: false },
        filterFrete: { type: Boolean, default: false },
        params: { type: Object },
        inUse: { type: Boolean },
    },

    data () {
        return {

            showMaisFiltros: false,

            filtroTipos: {
                list: [
                    { id: 0, label: 'Todos' },
                    { id: 1, label: 'Concluídos na loja virtual' },
                    { id: 2, label: 'Não concluídos na loja virtual' },
                ],
                index: 0,
            },

            filtroEspera: {
                list: [
                    { id: 0, label: 'Todas as Vendas' },
                    { id: 1, label: 'Vendas Em Espera' },
                ],
                index: 0,
            },

            filtroEquipes: {
                list: [],
                index: 0,
            },

            filtroUsuarios: {
                list: [],
                index: 0,
            },

            filtroStatusPedido: {
                list: [],
                index: 0,
            },

            filtroFretes: {
                list: [],
                index: 0,
            },

            base: {
                filial: { label: 'Filial', url: 'filial/', tipo: 'select2', varios: false, values: [{ id: null }] },
                segmento: { label: 'Segmento', url: 'ramoat/', tipo: 'select2', varios: false, values: [{ id: null }] },
                grupocliente: { label: 'Grupo de Clientes', url: 'grucli/', tipo: 'select2', varios: false, values: [{ id: null }] },
                cliente: { label: 'Cliente', url: 'cliente/', tipo: 'select2', varios: false, values: [{ id: null }] },
                clienteusuario: { label: 'Cliente', url: 'clienteusuario/', tipo: 'select2', varios: false, values: [{ id: null }] },
                estado: { label: 'Estado', url: 'estado/', tipo: 'select2', varios: false, values: [{ id: null }] },
                cidade: { label: 'Cidade', url: 'mun/', tipo: 'select2', varios: false, values: [{ id: null }] },
                grupoestoque: { label: 'Grupo de Produtos', url: 'gruest/', tipo: 'select2', varios: false, values: [{ id: null }] },
                produto: { label: 'Produto', url: 'item/', tipo: 'select2', varios: false, values: [{ id: null }] },
                formapagamento: { label: 'Forma de Pagamento', url: 'fpag/', tipo: 'select2', varios: false, values: [{ id: null }] },
            },

            filtros: [

            ],

            filtroPeriodos: [
                { data_inicio: null, data_termino: null, startDate: null, endDate: null }
            ],


            filtroPedidoSelected: null,
        }
    },

    components: {

    },

    computed: {
        labelTipos: function () {
            return this.filtroTipos.list[this.filtroTipos.index].label
        },

        labelEspera: function () {
            return this.filtroEspera.list[this.filtroEspera.index].label
        },

        usuarioLabel: function () {
            if (this.filtroUsuarios.list.length > 0)
                return this.filtroUsuarios.list[this.filtroUsuarios.index].label
            else
               return null
        },

        equipeLabel: function () {
            if (this.filtroEquipes.list.length > 0)
                return this.filtroEquipes.list[this.filtroEquipes.index].label
            else
               return null
        },

        statusLabel: function () {
            if (this.filtroStatusPedido.list.length > 0)
                return this.filtroStatusPedido.list[this.filtroStatusPedido.index].label
            else
               return null
        },

        usuarioList: function () {
            if (this.$store.getters.getUsuarioList)
                return this.$store.getters.getUsuarioList
            else
                return []
        },

        equipeList: function () { 
            if (this.$store.getters.getEquipeList)
                return this.$store.getters.getEquipeList
            else
                return []
        },

        statusList: function () {
            if (this.$store.getters.getPdstatusList)
                return this.$store.getters.getPdstatusList
            else
                return []
        },

        freteList: function () {
          if (this.$store.getters.getFreteList)
            return this.$store.getters.getFreteList
          else
            return []
        },

        freteLabel: function () {
            if (this.filtroFretes.list.length > 0)
               return this.filtroFretes.list[this.filtroFretes.index].label
            else
               return null
 
        },

        maisfiltrosLabel: function (){
          return null
        },

        administrador: function () {
            return SysVars.usuarioAdministrador
        },

        sessao: function () {
            return this.$store.getters.getSessao
        },


    },

    watch: {

    },

    filters: {

    },

    methods: {
        handleChangeUsuario (index) {
            console.log('handlechangeusuario')
            console.log(this.query)
            this.filtroUsuarios.index = index
            this.query.codusuario = this.filtroUsuarios.list[index].id
            if (this.query.codusuario == -1)
              this.query.codusuario = null
            this.$emit('change', this.query)
        },

        handleChangeFiltroTipo (index) {
            this.filtroTipos.index = index
            this.filtroPedidoSelected = this.filtroTipos.list[index]
            this.$emit('change', this.query)
        },

        handleChangeFiltroEspera (index) {
            this.filtroEspera.index = index
            this.query.espera = index
            this.$emit('change', this.query)
        },

        handleChangeEquipe (index) {
            this.filtroUsuarios.index = 0
            this.filtroEquipes.index = index
            this.query.codequipe = this.filtroEquipes.list[index].id
            if (this.query.codequipe == -1)
              this.query.codequipe = null
            this.$emit('change', this.query)
        },

        handleChangeStatus (index) {
            this.filtroStatusPedido.index = index
            this.query.codstatus = this.filtroStatusPedido.list[index].id
            if (this.query.codstatus == -1)
              this.query.codstatus = null
            this.$emit('change', this.query)
        },

        handleChangeFrete (index) {
          this.filtroFretes.index = index
          this.query.codfrete = this.filtroFretes.list[index].id
          if (this.query.codfrete == -1)
              this.query.codfrete = null
          this.$emit('change', this.query)
        },

        async preparaFiltro () {
            await this.$store.dispatch('loadUsuariosDashboard', this)
            await this.$store.dispatch('loadEquipesDashboard', {})
            await this.$store.dispatch('loadPdstatus', {})
            await this.$store.dispatch('loadFrete', {})

            //monta a lista de usuarios e equipes
            if (this.usuarioList.length > 1){
              this.filtroUsuarios.list = [ { id: -1, label: 'Todos' } ]
            }
            for (var x = 0; x < this.usuarioList.length; x++) {
                this.filtroUsuarios.list.push({ id: this.usuarioList[x].codusuario, label: this.usuarioList[x].nome })
            }

            this.filtroEquipes.list = [ { id: -1, label: 'Todos' } ]
            if (this.equipeList.length > 0) {
                for (var x = 0; x < this.equipeList.length; x++) {
                    this.filtroEquipes.list.push({ id: this.equipeList[x].codequipe, label: this.equipeList[x].nome })
                }
            }

            this.filtroStatusPedido.list = [ { id: -1, label: 'Todos' } ]
            if (this.statusList.length > 0) {
                for (var x = 0; x < this.statusList.length; x++) {
                    this.filtroStatusPedido.list.push({ id: this.statusList[x].codstatus, label: this.statusList[x].descricao })
                }
            }

            this.filtroFretes.list = [ { id: -1, label: 'Todos' } ]
            if (this.freteList.length > 0) {
                for (var x =0; x < this.freteList.length; x++) {
                    this.filtroFretes.list.push({ id: this.freteList[x].id, label: this.freteList[x].value })
                }
            }

        },

        inicializa () {
            let obj = null

            for (var x = 0; x < this.params.filtros.length; x++) {

                obj = this.base[this.params.filtros[x].nome]
                obj.nome = this.params.filtros[x].nome

                if (this.params.filtros[x].label)
                  obj.label = this.params.filtros[x].label

                if (this.params.filtros[x].url)
                  obj.url = this.params.filtros[x].url

                if (this.params.filtros[x].varios)
                  obj.varios = this.params.filtros[x].varios

                //aqui carrega os valores para os filtros vindos do PARENT
                if (this.params.filtros[x].values && this.params.filtros[x].values.length > 0) {
                    obj.values = []
                    for (var y = 0; y < this.params.filtros[x].values.length; y++) {
                        obj.values.push({ id: this.params.filtros[x].values[y] })
                    }
                    // console.log(obj.values)
                }
                //

                this.filtros.push(obj)
            }


            if (this.params.periodos)
                this.filtroPeriodos = this.params.periodos
            else
            if (this.params.periodo) {
                this.filtroPeriodos = [{
                        label: this.params.periodo.label, 
                        field: this.params.periodo.field,
                        varios: this.params.periodo.varios,
                        values:[
                          {
                              data_inicio: this.params.periodo.data_inicio,
                              data_termino: this.params.periodo.data_termino,
                              startDate: this.params.periodo.data_inicio,
                              endDate: this.params.periodo.data_termino,
                          }
                        ]
                      }
                    ]
            }


            /*
            query string
            datainicial=99-99-9999&datafinal=99-99-9999&filial=1&grupoestoque=1&grupocliente=1
            */

        },

        change () {
            let filtro = {}

            let periodos = []

            for (var x = 0; x < this.filtroPeriodos.length; x++) {
              let hasvalue = false
              for(var y = 0; y < this.filtroPeriodos[x].values.length; y++){
                this.filtroPeriodos[x].values[y].data_inicio = this.filtroPeriodos[x].values[y].startDate
                this.filtroPeriodos[x].values[y].data_termino = this.filtroPeriodos[x].values[y].endDate
                if (this.filtroPeriodos[x].values[y].data_inicio || this.filtroPeriodos[x].values[y].data_termino) hasvalue = true
                  
              }
              if (hasvalue)
                periodos.push(this.filtroPeriodos[x])
            }

            filtro.periodos = periodos

            this.params.periodos = periodos //atualiza os periodos no objeto pai

            let obj = null
            let values = null

            for (var x = 0; x < this.filtros.length; x++) {
                values = []
                for (var y = 0; y < this.filtros[x].values.length; y++) {
                    if (this.filtros[x].values[y].id)
                      values.push(this.filtros[x].values[y].id)
                }
                if (values.length > 0) 
                  filtro[this.filtros[x].nome] = values
            }
        
            if (this.params.checkbox && this.params.checkbox.length){
              for (var x = 0; x < this.params.checkbox.length; x++) {
                filtro[this.params.checkbox[x].nome] = this.params.checkbox[x].value
              }
            }

            if (this.params.selects && this.params.selects.length){
              for (var x = 0; x < this.params.selects.length; x++) {
                if (this.params.selects[x].id)
                  filtro[this.params.selects[x].nome] = this.params.selects[x]
              }
            }

            this.showMaisFiltros = false

            this.$emit('change', filtro)
        },

        cancel() {
            this.showMaisFiltros=false            
            this.$emit('cancel')
        },

        handlePeriodoChange(index) {
            //alteracao de periodo
        },

        handleAdicionaFiltro (flt, index) {
            flt.values.push({ id: null })

        },

        handleAdicionaPeriodo (idx) {
            this.filtroPeriodos[idx].values.push({ data_inicio: null, data_termino: null, startDate: null, endDate: null })

            // console.log(this.$route.query)

            // let query = JSON.parse(JSON.stringify(this.$route.query));
            // query.segmento = [1]

            // // this.$router.replace({ query: query })
            // window.location.hash = '#/?segmento=5'
            // console.log(window.location.hash.slice(1))

        },

        handleExcluiPeriodo (idx, index) {
            this.filtroPeriodos[idx].values.splice(index, 1)
        },


        handleExcluiValueFiltro(flt , index){
          flt.values.splice(index, 1)
        },

        async loadData () {
            //CARREGA DADOS DA SESSAO
            await this.$store.dispatch('loadSessao', this)

            //CARREGA LISTA DE USUARIOS
            await this.$store.dispatch('loadUsuariosDashboard', this)
        },



    },

    mounted () {

        let vm = this
        this.keytimer = setTimeout(function(){
            // console.log(vm.filtros)
            vm.show = true
        }, 100);

    },


    created () {
        this.preparaFiltro()
        this.inicializa()
    }

}

</script>

<template>
    <div class="row align-items-center mb-3">
        <div class="col-12">
            <span class="lbl" v-if="filterTipos" >Pedidos
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ labelTipos }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(filtro, index) in filtroTipos.list" :key="index" 
                            @click="handleChangeFiltroTipo(index)">{{ filtro.label }}</a>
                    </div>
            </span>
            <span class="lbl" v-if="filterEspera" >Vendas em Espera
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ labelEspera }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(filtro, index) in filtroEspera.list" :key="index" 
                            @click="handleChangeFiltroEspera(index)">{{ filtro.label }}</a>
                    </div>
            </span>
            <span class="lbl pl-3" v-if="filterStatus && (filtroStatusPedido.list.length > 1)">Status
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ statusLabel }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(item, index) in filtroStatusPedido.list" :key="index" 
                            @click="handleChangeStatus(index)">{{ item.label }}</a>
                    </div>
            </span>
            <span class="lbl pl-3" v-if="filterUsuarios && (filtroUsuarios.list.length > 1)">Usuário
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ usuarioLabel }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(item, index) in filtroUsuarios.list" :key="index" 
                            @click="handleChangeUsuario(index)">{{ item.label }}</a>
                    </div>
            </span>
            <span class="lbl pl-3" v-if="filterEquipes && (filtroEquipes.list.length > 1)">Equipe
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ equipeLabel }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(item, index) in filtroEquipes.list" :key="index" 
                            @click="handleChangeEquipe(index)">{{ item.label }}</a>
                    </div>
            </span>
            <span class="lbl pl-3" v-if="filterFrete && (filtroFretes.list.length > 1)">Forma de Envio
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ freteLabel }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(item, index) in filtroFretes.list" :key="index" 
                            @click="handleChangeFrete(index)">{{ item.label }}</a>
                    </div>
            </span>
            <span class="lbl pl-3" v-if="params">Mais Filtros
                <a href="#" class="dropdown-toggle" style="cursor: pointer" tabindex="1" @click="showMaisFiltros = !showMaisFiltros"> {{ maisfiltrosLabel }} <span class="badge badge-info" id="badge" v-if="inUse"> <span class="caret"></span></span><span class="caret"></span></a>
            </span>
      </div>

      <div class="border p-4" v-if="showMaisFiltros" >
        <div class="row" v-if="filtroPeriodos && filtroPeriodos > 0">
            <div class="col-md-12 col-12 mb-3">
                <span class="lbl-deal-subtitle">Período</span>
            </div>
        </div>

        <div class="row mb-3" v-for="(item, idx) in filtroPeriodos" v-if="filtroPeriodos && filtroPeriodos.length > 0">
            <div class="col-md-12 col-12">
                <v-label :label="item.label"></v-label>
            </div>
            <div class="col-md-12 col-12 d-flex" v-for="(periodo, index) in item.values" :key="index">
                <input-month2 :p-month="periodo" @monthChange="handlePeriodoChange(idx, index)"></input-month2>
                <v-button v-if="item.values.length > 1" class="ml-3" icon="fa-trash" :link="true" @click="handleExcluiPeriodo(idx, index)"></v-button>
            </div>
            <div v-if="item.varios" class="col-md-12 col-12">
                <v-button label="Adicionar Período" icon="fa-plus" :link="true" @click="handleAdicionaPeriodo(idx)"></v-button>
            </div>
            <hr>
        </div>

        <div class="row" v-if="((filtros && filtros.length > 0) || (params.checkbox && params.checkbox.length > 0) || (params.selects && params.selects.length > 0))">
            <div class="col-md-12 col-12 mb-3">
                <span class="lbl-deal-subtitle">Filtros</span>
            </div>
        </div>

        <div class="mb-2" v-for="(flt, index) in filtros" :key="index">
          <div class="row" v-for="(value, index2) in flt.values" :key="index2">
            <div class="col-md-12 col-12">
                <v-label :label="flt.label"></v-label>
            </div>
            <div class="col-10">
                <form-field v-model="value.id" type="select2" :select2="{ entity: flt.url, minlength: 0 }" :placeholder="flt.label"></form-field>
            </div>
            <div class="col-2">
              <v-button v-show="flt.values.length > 1" icon="fa-trash" :link="true" @click="handleExcluiValueFiltro(flt, index2)"></v-button>
            </div>
          </div>
          <div v-if="flt.varios" class="row mb-4">
            <div class="col-md-12 col-12">
              <v-button label="Adicionar" icon="fa-plus" :link="true" @click="handleAdicionaFiltro(flt)"></v-button>
            </div>
          </div>
        </div>

        <div v-for="(check, index) in params.checkbox" :key="index">
            <div class="row">
                <div class="col-md-12 col-12">
                    <input-checkbox v-model="check.value" :label="check.label"  :value-checked="check.valueChecked" :value-unchecked="check.valueUnchecked"></input-checkbox>
                </div>
            </div>
        </div>
        <div v-for="(select, index) in params.selects" :key="index">
            <div class="row">
                <div class="col-md-6 col-12 d-flex-inline">
                    <form-field v-model="select.id" type="select2static" :label="select.label"  :placeholder="select.placeholder" :select-options="select.options"></form-field>
                </div>
                <div class="col-md-6 col-12 d-flex-inline" v-if="select.hasOwnProperty('value')">
                    <form-field v-model="select.value" type="text" case="normal" :label="select.value_label"  :placeholder="select.value_placeholder"></form-field>
                </div>
           </div>
        </div>

        <div class="filtro-bar-footer pt-5">
              <v-button label="Ok" @click="change"></v-button>
              <v-button label="Cancelar" @click="cancel"></v-button>
        </div>



      </div>

    </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/components/pedido-filtro.vue